import {
  CONTRACTOVERVIEW_STATES,
  CONTRACTCODE_STATES,
} from "./ContractInfo.constants";

const initialState = {
  overviewStatus: CONTRACTOVERVIEW_STATES.idle,
  codeStatus: CONTRACTCODE_STATES.idle,
  overview: null,
  code: null,
  token: null,
  overviewError: null,
  codeError: null,
};

const ContractInfo = (
  state = initialState,
  action: {
    type: string;
    overview: any;
    code: any;
    token: string;
    error: any;
  }
) => {
  switch (action.type) {
    case "GET_CONTRACTOVERVIEW":
      return {
        ...state,
        overviewStatus: CONTRACTOVERVIEW_STATES.loading,
        token: action.token,
        overviewError: null,
      };
    case "GET_CONTRACTOVERVIEW_SUCCESS":
      return {
        ...state,
        overviewStatus: CONTRACTOVERVIEW_STATES.success,
        overview: action.overview,
        overviewError: null,
      };
    case "GET_CONTRACTOVERVIEW_FAILURE":
      return {
        ...state,
        overviewStatus: CONTRACTOVERVIEW_STATES.failure,
        overview: null,
        overviewError: action.error,
      };
    case "GET_CONTRACTCODE":
      return {
        ...state,
        codeStatus: CONTRACTCODE_STATES.loading,
        token: action.token,
        codeError: null,
      };
    case "GET_CONTRACTCODE_SUCCESS":
      return {
        ...state,
        codeStatus: CONTRACTCODE_STATES.success,
        code: action.code,
        codeError: null,
      };
    case "GET_CONTRACTCODE_FAILURE":
      return {
        ...state,
        codeStatus: CONTRACTCODE_STATES.failure,
        code: null,
        codeError: action.error,
      };
    default:
      return state;
  }
};

export default ContractInfo;
